import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DocumentsService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GuiaModel } from 'src/app/models/guia.model';
import Swal from "sweetalert2";
import { Router } from '@angular/router';
import {MacrosDiaComponent} from "./macros-dia/macros-dia.component";
import {RegistroAlimentosComponent} from "../analisis-alimentacion/registro-alimentos/registro-alimentos.component";
declare var $: any;

@Component({
  selector: 'app-guias',
  standalone: true,
  imports: [
    CommonModule,
    // ReactiveFormsModule,
    FormsModule,
    MacrosDiaComponent,
    RegistroAlimentosComponent
  ],
  templateUrl: './guias.component.html',
  styleUrl: './guias.component.css'
})
export class GuiasComponent implements OnInit, OnChanges{
  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;
  @Output() programaClienteActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  documentIdGuiaSeleccionada: any;
  guiaSeleccionada: any;
  // @Input({required: true}) textoEditado: any;
  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  listaGuias: any = [];
  listaGuiasOriginal: any = [];
  patternGuias: string = 'guia';
  sectionActive: 'calculo' | 'guias' = 'guias';
  // guiaSeleccionada: any;

  filtrarGuiaPorCatePlatillo = 'todos'
  platillosFiltrados: any;

  constructor(
    private documentService: DocumentsService,
    private router: Router){ }
  
  ngOnInit(): void {
    this.getGuias();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges =======================================")
    this.guiaSeleccionada = this.detallePrograma?.guiaSeleccionada;
    if (changes.detallePrograma) {// && !changes.detallePrograma.isFirstChange()) {
      if(this.detalleCliente && this.detallePrograma.tipo == '1') {
        const indexPrograma = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
        if(indexPrograma != -1) {
          console.log(indexPrograma)
          this.detallePrograma.guias = this.detalleCliente.expediente.programas[indexPrograma].configuracionPrograma.guias ? [...this.detalleCliente.expediente.programas[indexPrograma].configuracionPrograma.guias] : [];
          this.detallePrograma.guiaSeleccionada = this.detalleCliente.expediente.programas[indexPrograma].configuracionPrograma.guiaSeleccionada ? this.detalleCliente.expediente.programas[indexPrograma].configuracionPrograma.guiaSeleccionada : {};
          this.documentIdGuiaSeleccionada = this.detalleCliente.expediente.programas[indexPrograma].configuracionPrograma.guiaSeleccionada?.documentId;
        }
      } else this.documentIdGuiaSeleccionada = this.detallePrograma?.guiaSeleccionada?.documentId;
      
      // Llama a la función cada vez que detallePrograma cambia
      if(this.detallePrograma.guiaSeleccionada && this.detallePrograma.guias.length > 0 && this.listaGuiasOriginal.length > 0) {
        this.filtrarPlatillosPorCategoria('todos', this.detallePrograma.guiaSeleccionada);
      }
      console.log('detallePrograma', this.detallePrograma)
    }
  }
  navigateToGuias() {
    if(this.detalleCliente && this.detallePrograma.tipo == '1') {
      this.router.navigate(['trainer/guias', this.detalleCliente.documentId, this.detallePrograma.documentId])
    }
    if(this.detallePrograma.tipo == '2') {
      this.router.navigate(['trainer/guias', this.detallePrograma.documentId])
    }
  }
  changeSectionActive(section: 'calculo' | 'guias')
  {
    this.sectionActive = section;
  }
  getGuias()
  {
    console.log("getGuias()")
    this.listaGuias = [];
    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.patternGuias
    ).subscribe({
      next: (data: any) => {
        console.log(data.content)
        this.listaGuiasOriginal = [...data.content];
        this.listaGuias = [...data.content];
        console.log(this.listaGuias)

        // Aplica para el inicio, cuando traiga las guias se filtra el tipo de platillo en guias para mostrar la info de la seleccionada
        if(this.detallePrograma.guiaSeleccionada && this.detallePrograma.guias.length > 0 && this.listaGuiasOriginal.length > 0) {
          this.filtrarPlatillosPorCategoria('todos', this.detallePrograma.guiaSeleccionada);
        }
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
      }
    })
  }

  guardarCambios(opcion: 'listaGuias' | 'guiaSeleccionada', documentIdGuiaSeleccionada) {
    this.documentIdGuiaSeleccionada = documentIdGuiaSeleccionada
    if(this.detallePrograma.tipo == '1') {
      this.updateClienteDocument(opcion);
    } else if(this.detallePrograma.tipo == '2') {
      this.updateProgramaDocument(opcion);
    }
  }
  updateClienteDocument(opcion: 'listaGuias' | 'guiaSeleccionada')
  {
    // console.log("=========================== updateClienteDocument =======================================")
    const indexPrograma = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
    let programas = [...this.detalleCliente.expediente.programas];

    if(opcion == 'guiaSeleccionada') {
      const index = this.listaGuias.findIndex((item) => item.documentId === this.documentIdGuiaSeleccionada);
      programas[indexPrograma].configuracionPrograma.guiaSeleccionada = {
        nombre: this.listaGuias[index].nombre,
        documentId: this.listaGuias[index].documentId
      }
    }
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    console.log('expedienteClienteDocument', expedienteClienteDocument)
    
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'Las guías del programa han sido actualizadas.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });
        $("#modal-asignarGuias").modal('hide');
        this.listaGuias = [...this.listaGuiasOriginal]

        // Emitir el evento hacia el padre
        this.programaClienteActualizado.emit();
      }
    })
  }
  updateProgramaDocument(opcion: 'listaGuias' | 'guiaSeleccionada')
  {
    // console.log("=========================== updateProgramaDocument =======================================")
    
    let programaDocument: any = {}
    if(opcion == 'guiaSeleccionada') {
      const index = this.listaGuias.findIndex((item) => item.documentId === this.documentIdGuiaSeleccionada);
      programaDocument.guiaSeleccionada = {
        nombre: this.listaGuias[index].nombre,
        documentId: this.listaGuias[index].documentId
      }
      // programaDocument.guiaSeleccionada = this.guiaSeleccionada;
    }
    console.log('programaDocument', programaDocument)
    
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // Swal.fire({
        //   toast: true, // Activa el estilo tipo Toast
        //   position: 'bottom-end', // Posición del mensaje
        //   icon: 'success',
        //   title: 'Las guías del programa han sido actualizadas.',
        //   showConfirmButton: false,
        //   timer: 5000, // Tiempo de duración del mensaje (5 segundos)
        //   timerProgressBar: true // Muestra una barra de progreso
        // });
        $("#modal-asignarGuias").modal('hide');
        this.listaGuias = [...this.listaGuiasOriginal]
        // Emitir el evento hacia el padre
        this.programaActualizado.emit();
      }
    })
  }
  
  filtrarPlatillosPorCategoria(opcion, guiaSeleccionada): void {
    console.log("================ filtrar ===================")
    console.log(opcion)
    let index = this.listaGuiasOriginal.findIndex((item) => item.documentId === guiaSeleccionada?.documentId);
    this.guiaSeleccionada = this.listaGuiasOriginal[index];
    this.filtrarGuiaPorCatePlatillo = opcion
    if (this.filtrarGuiaPorCatePlatillo === 'todos') {
      // Si la categoría es "todos", muestra todos los platillos
      this.platillosFiltrados = this.guiaSeleccionada.detalle;
    } else {
      // Filtra los platillos según la categoría seleccionada
      this.platillosFiltrados = this.guiaSeleccionada.detalle.filter((platillo: any) => platillo.categoria === this.filtrarGuiaPorCatePlatillo);
    }
    this.inicializarDataTableDetalleGuiaSeleccionada();
  }
  
  dataTableDetalleGuiaSeleccionada: any;
  inicializarDataTableDetalleGuiaSeleccionada() {
    if (this.dataTableDetalleGuiaSeleccionada) {
      this.dataTableDetalleGuiaSeleccionada.destroy(); // Destruir la instancia existente de la DataTable
    }
    // Asegurarse de que el DOM está actualizado antes de reiniciar DataTable
    $(document).ready(() => {
      this.dataTableDetalleGuiaSeleccionada = $('#dataTable-detalleGuiaSeleccionada').DataTable({
          language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla",
        },
        pageLength: 10,
      });
    }, 0); // Retardo para esperar a que el DOM se actualice
  }
  // listaGuiasEnPrograma: any = [];

}
